<template>
  <div class="create-tenant">
    <div class="section-header">
      <div class="section-header__left">
        <div class="section-header__icon">
          <i class="el-icon-s-cooperation"></i>
        </div>
        <div>
          <h2 class="section-header__title">{{ $t('settings.tenantCreate') }}</h2>
          <p class="section-header__subtitle">{{ $t('settings.tenantSection') }}</p>
        </div>
      </div>
      <base-button
        icon="el-icon-back"
        @click="$router.push({path: '/app/tenants'})">
        {{ $t('settings.backToTenants') }}
      </base-button>
    </div>

    <tenant-form
      mode="create"
      @submit="onSubmit"
      :error="responseError"
      :loading="loading">
    </tenant-form>
  </div>
</template>

<script>
import BaseButton from '@/components/common/BaseButton';
import {createNamespacedHelpers} from 'vuex';
import TenantForm from './TenantForm';

const tenantStateMappers = createNamespacedHelpers('tenant');

export default {
  name: "CreateTenant",
  components: {TenantForm, BaseButton},
  data() {
    return {
      loading: false,
      responseError: '',
    }
  },
  methods: {
    ...tenantStateMappers.mapActions(['createTenant']),
    onSubmit(tenant) {
      this.loading = true;
      this.createTenant(tenant).then(() => {
        this.$message.info(this.$t('settings.tenantCreated'));
        setTimeout(() => this.$router.replace({path: '/app/tenants'}), 200);
      }).catch(() => {
        this.responseError = this.$t('settings.genericHttpError');
        this.$message({
          message: this.$t('settings.genericHttpError'),
          type: 'error',
          duration: 10000,
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped lang="scss">
.create-tenant {
  padding: 0 15px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &__left {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  &__icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      color: var(--bg-surface);
      font-size: 18px;
    }
  }

  &__title {
    margin: 0 0 2px;
    font-size: 17px;
    font-weight: 600;
    color: var(--text-primary);
    line-height: 1.3;
  }

  &__subtitle {
    margin: 0;
    font-size: 12px;
    color: var(--text-secondary);
    line-height: 1.4;
  }
}

@media (max-width: 767px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
  }
}
</style>
